// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__5-G9c","containerItemsCenter":"Skeleton_containerItemsCenter__lIPnU"};